import { SortOrder } from '../analytics/utils/generateQueryParams'
import { ActionType } from '../analytics/analytics.interface'

// Define ActionTrigger here to avoid circular dependencies
export enum ActionTrigger {
  FILTER = 'filter',
  SERVICE = 'service',
  CUSTOM_RULE = 'custom_rule',
  CUSTOM = 'custom',
  DEFAULT = 'default',
  GLOBAL = 'global',
  REBIND = 'rebind',
}

export enum SearchQuestionMode {
  INCLUDES = 'includes',
  STARTS_WITH = 'startsWith',
  ENDS_WITH = 'endsWith',
  EXCLUDES = 'excludes',
  APEX = 'apex',
}

export enum SearchEndpointMode {
  INCLUDES = 'includes',
  STARTS_WITH = 'startsWith',
  ENDS_WITH = 'endsWith',
  EXCLUDES = 'excludes',
}

export interface GeoIPData {
  countryCode?: string
  city?: string
  isp?: string
  asn?: number
}

export interface QueryData {
  timestamp: string
  userId?: string
  endpointId?: string
  clientId?: string
  profileId?: string
  question: string
  domainCategory?: string
  rrType?: string
  sourceIp?: string
  statusCode?: number
  protocol?: string
  answers?: Array<{
    ips?: string[]
    geoip?: GeoIPData
  }>
  action: number
  trigger?: string
  triggerValue?: string
  spoofTarget?: string
  sourceGeoip?: GeoIPData
}

export interface PaginationData {
  totalPages: number
  totalItems: number
  page: number
  pageSize: number
}

export interface HistoricalQueriesResponse {
  meta: PaginationData
  queries: QueryData[]
}

export interface AuthTokenResponse {
  token: string
}

export type ActivityLogParams = {
  startTime: string
  endTime?: string
  region: string
  endpointId?: string | string[]
  clientId?: string | string[]
  action?: ActionType | ActionType[]
  trigger?: ActionTrigger | ActionTrigger[]
  triggerValue?: string | string[]
  spoofTarget?: string | string[]
  question?: string | string[]
  profileId?: string | string[]
  searchQuestion?: string
  searchQuestionMode?: SearchQuestionMode
  searchEndpoint?: string
  searchEndpointMode?: SearchEndpointMode
  protocol?: string[]
  statusCode?: number | number[]
  rrType?: string | string[]
  srcCountry?: string[]
  dstCountry?: string[]
  dstAsn?: number[]
  srcAsn?: number[]
  dstIsp?: string[]
  srcIsp?: string[]
  page?: number
  pageSize?: number
  sortOrder?: SortOrder
}

export type RealtimeActivityLogParams = Omit<ActivityLogParams, 'page' | 'pageSize'> & {
  authToken?: string
}

export type CSVActivityLogParams = Omit<ActivityLogParams, 'page' | 'pageSize'>

export type DeleteActivityLogParams = {
  region: string
  endpointId?: string
  clientId?: string | string[]
}

// UI type for activity logs with client-generated id
export type ActivityLog = QueryData & { id: string }
